import { render, staticRenderFns } from "./AddToSegment.vue?vue&type=template&id=258bfd79"
import script from "./AddToSegment.vue?vue&type=script&lang=js"
export * from "./AddToSegment.vue?vue&type=script&lang=js"
import style0 from "./AddToSegment.vue?vue&type=style&index=0&id=258bfd79&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports